import { IfilterArguments, IFilter } from "../types/cardType"
import { getUniqueValues } from "../helpers/siteHelpers"
import { useEffect, useState } from "react"

const FilterMenu:React.FC<IFilter> = ({ definedTours, showFilterMenu, setShowFilterMenu, setFiltered, setIsFiltered}) => {

    const [ holidayTourStyles, setHolidayTourStyles ] = useState<string[]>([])
    const [ tourDurations, setTourDurations ] = useState<string[]>([])
    const [ tourLocations, setTourLocations ] = useState<string[]>([])
    const [ filters, setFilters ] = useState<IfilterArguments>({styles:[],durations:[],destinations:[]})

    useEffect(()=> {
     definedTours && setHolidayTourStyles(getUniqueValues( definedTours, 'DDTourType' ).sort())
     definedTours && setTourDurations(getUniqueValues( definedTours, 'DDDurationCategory' )) 
     definedTours && setTourLocations(getUniqueValues( definedTours, 'primaryCategory' ).sort())
    },[])

    useEffect(() => {
      let tmp = [...definedTours]
       //filter styles
       if(filters.styles.length > 0){
        tmp = tmp.filter((item) => {
          return filters.styles.includes(item.DDTourType)
        })
       }
       //filter durations
       if(filters.durations.length > 0){
        tmp = tmp.filter((item) => {
          return filters.durations.includes(item.DDDurationCategory)
        })
       }
       //filter destinations
       if(filters.destinations.length > 0){
        tmp = tmp.filter((item) => {
          return filters.destinations.includes(item.primaryCategory)
        })
       }
       setFiltered(tmp)
       setIsFiltered(true)
    },[filters])

    return (
        <>
        <aside className={
          `d-flex flex-column position-absolute top-0 mt-5 col col-12 col-lg-3 p-0 bg-light shadow-sm zindex-2 p-3 start-off flex-fill ${showFilterMenu ? 'slide-in':'slide-out'}`
        }>
            <div className="h-100 w-100">
           
               <i className="icon-close float-end hover text-dark" 
                  onClick={() => setShowFilterMenu(!showFilterMenu)}></i>
             
                <h3 className="text-center">Filters</h3>

            <div className="mt-3 text-start">
            <h4 className="mb-3">Holiday &amp; Tour Styles</h4>
            {holidayTourStyles && holidayTourStyles.length > 0 && holidayTourStyles.map((style:string, index:number) => {
                return (
                <div className="form-check text-start" key= {index + '-' + style}>
                    <input className="form-check-input" 
                           type="checkbox" 
                           value={style}  
                           onChange={(e)=>{
                            if(e.target.checked){
                            let tmp = {...filters}
                            tmp.styles.push(style)
                            setFilters(tmp)
                            } else {
                             let tmp = {...filters}
                             const index = tmp.styles.indexOf(style) 
                             index > -1 && tmp.styles.splice(index,1)
                             setFilters(tmp)
                            }
                    }}/>
                    <label className="form-check-label ps-3" htmlFor="styleCheckLabel">
                      {style}
                    </label>
                  </div>
                )
            })}
            </div>
            
            <div className="mt-3 text-start">   
            <h4 className="mb-3">Tour Durations</h4>
            {tourDurations && tourDurations.length > 0 && tourDurations.map((duration:string, index:number) => {
                return (
                <div className="form-check" key={index + '-' + duration}>
                    <input className="form-check-input" 
                           type="checkbox" 
                           value={duration}
                           onChange={(e)=>{
                            if(e.target.checked){
                            let tmp = {...filters}
                            tmp.durations.push(duration)
                            setFilters(tmp)
                            } else {
                             let tmp = {...filters}
                             const index = tmp.durations.indexOf(duration) 
                             index > -1 && tmp.durations.splice(index,1)
                             setFilters(tmp)
                            }
                    }} 
                           />
                    <label className="form-check-label ps-3" htmlFor="durationCheckLabel">
                      {duration}
                    </label>
                  </div>
                )
            })}
            </div>

            <div className="mt-3 text-start">
            <h4 className="mb-3">Tour Locations</h4>
            {tourLocations && tourLocations.length > 0 && tourLocations.map((location:string, index:number) => {
                return (
                <div className="form-check" key={index + '-' + location}>
                    <input className="form-check-input" 
                           type="checkbox" 
                           value={location}
                           onChange={(e)=>{
                            if(e.target.checked){
                            let tmp = {...filters}
                            tmp.destinations.push(location)
                            setFilters(tmp)
                            } else {
                             let tmp = {...filters}
                             const index = tmp.destinations.indexOf(location) 
                             index > -1 && tmp.destinations.splice(index,1)
                             setFilters(tmp)
                            }
                    }} />
                    <label className="form-check-label ps-3" htmlFor="locationCheckLabel">
                      {location}
                    </label>
                  </div>
                   
                )
            })}
            </div>
            <button className="btn btn-dark rounded-0 tf-orange float-end p-3" onClick={()=>setShowFilterMenu(false)}>Apply</button>
            </div>
        </aside>
        </>
    )
}
export default FilterMenu